// Import 3rd party libraries
import {gsap} from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

let hasRun = false;

export default function() {
    const matches = {
        isMobile: "(max-width: 480px)",
        isLandscape: "(orientation: landscape)",
        isPortrait: "(orientation: portrait)",
    };

    gsap.matchMedia().add(matches, (context) => {
        if (!hasRun) {

            let fabTimeline = gsap.timeline();
            fabTimeline.delay(4);

            // Fade in the FAB
            fabTimeline.to("#fab input", {
                "checked": false
            });

            fabTimeline.to("#fab",
                {
                    opacity: 1,
                    duration: 1.5,
                    ease: "power2.inOut"
                },
            );

            fabTimeline.to("#fab input", {
                "checked": true
            });

            fabTimeline.to("#fab input", {
                "checked": () => {
                    let state = window.localStorage.getItem('fabClosed') || "closed";

                    if(state === "closed") {
                        window.localStorage.setItem('fabClosed', "closed");
                    }

                    return state === 'open';
                }
            }, "+=1")
        }

    });
}